import { Schema } from '../create/components/district-form.schema';
import { DistrictForm } from '../create/components/district-form';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { useUpdateDistrictMutation } from '../mutations';
import { useDistrictQuery } from '../queries';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { idParamSchema } from '~/schemas';

export const Page = withPrivateRoute(() => {
  const mutation = useUpdateDistrictMutation();
  const navigate = useNavigate();

  const { id } = useParams(idParamSchema.parse);
  const { data } = useDistrictQuery(id);

  async function onSubmit(payload: Schema) {
    const { data } = await mutation.mutateAsync({ id, payload });
    navigate(`../${data.id}`);
  }

  if (!data) {
    return false;
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Redigera distrikt" />

      <PageLayout.Section>
        <DistrictForm
          defaultValues={{ ...data, region: data.region.id, email: data.email ?? '' }}
          onSubmit={onSubmit}
          isLoading={false}
          mode="edit"
        />
      </PageLayout.Section>
    </Fragment>
  );
});
